import { render, staticRenderFns } from "./HrView.vue?vue&type=template&id=b50d71fc"
import script from "./HrView.ts?vue&type=script&lang=ts&external"
export * from "./HrView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports